import React, {PureComponent} from "react"
import {withRouter, WithRouter} from "react-router-dom"

import {FormattedMessage} from "@irati/utils/lang"
import history from "@irati/utils/history"
import Routes, {SETUP_TENANT} from "@irati-web/app/src/routeConfig"
import Icon from "@irati/ui/src/Icon"
import {TENANT_SETUP_TOUR_PREFIX} from "../../tour"
import {isPathActive, getCurrentTenantSetupStepConfig} from "../../helpers"
import {InviteAdminWrapper, SpacedPara} from "./styled"

interface Props extends WithRouter {}

class InviteAdmin extends PureComponent<Props> {
  handleClick = () => {
    const lastVisitedStep = getCurrentTenantSetupStepConfig()
    if (lastVisitedStep) {
      const lastVisitedStepPath = lastVisitedStep!.nestedPath
      history.push({
        pathname: `${Routes[SETUP_TENANT]}/invite-admin`,
        state: {
          lastVisitedStepPath
        }
      })
    } else {
      history.push(`${Routes[SETUP_TENANT]}/invite-admin`)
    }
  }

  render() {
    return (
      <InviteAdminWrapper
        data-tour={`${TENANT_SETUP_TOUR_PREFIX}step03`}
        alignItems="center"
        onClick={this.handleClick}
        active={isPathActive("invite-admin")}>
        <Icon size={30} icon="addAdmin" />
        <SpacedPara flush>
          <FormattedMessage id="setup_tenant.inviteAdmin.title" />
        </SpacedPara>
      </InviteAdminWrapper>
    )
  }
}

export default withRouter(InviteAdmin)
